<template>
  <div>
    <div v-for="department in departments" :key="department.category_id">
      <XsMenus v-if="department.category_id === 'Menu'" />
      <div v-else class="background-color-white mb-3">
        <v-row align="center" no-gutters>
          <!-- comp -->
          <v-col class="d-flex primary--text py-2">
            <div class="align-center d-flex pl-4">
              <Icon
                  :name="department.src"
                  :color="$vuetify.theme.themes.light.primary"
                  :title="department.name"
                  :style="{height:'24px', width: '24px'}"
              ></Icon>
              <h3 class="pl-2 text-no-wrap">{{ department.name }}</h3>
            </div>
          </v-col>
          <!-- comp -->
          <v-col cols="3" class="d-flex justify-center">
            <router-link
              class="align-center d-flex font-size-sm"
              :to="
                routeToDepartment(
                  department.category_id,
                  department.sub_categories
                )
              "
            >
              View All
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </router-link>
          </v-col>
          <!-- comp -->
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-sheet :max-width="fixedRowWidth">
              <swiper :options="{ slidesPerView: 2.25 }">
                <swiper-slide
                  class="d-flex justify-center"
                  v-for="product in department.products"
                  :key="product.upc"
                >
                  <Product :product="product" :size="'xs'" />
                </swiper-slide>
              </swiper>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Product from "@/components/Product/index.vue";
import XsMenus from "@/components/Departments/Xs/Menus.vue";
import Icon from '@/components/UI/Icon.vue'

export default {
  name: "XsDepartments",
  components: {
    Icon,
    Product,
    XsMenus,
  },
  computed: {
    ...mapState({
      departments: (state) => state.departments.data,
    }),
    fixedRowWidth() {
      return this.innerWidth;
    },
  },
  created() {
    window.addEventListener("resize", this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.setInnerWidth);
  },
  methods: {
    routeToDepartment(departmentId, categories) {
      const departmentRoute = `/department/${departmentId}`;
      const departmentRouteWithoutCategories = `/department/${departmentId}/category/${departmentId}`;
      return categories ? departmentRoute : departmentRouteWithoutCategories;
    },
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    }
  }
};
</script>
